// @ts-nocheck
// EditClubSheet — admin/owner edita dados do grupo (nome, descrição,
// privacidade, regras de post). Sheet bottom-up igual ao milestones-sheet.
//
// Usa PATCH /api/clubs/:id (api.patchClub).
import React, { useState, useEffect } from 'react';
import { Icon } from '../icons';
import { api } from '../../services/apiV2';
import { CoverCropper } from './cover-cropper';

export const EditClubSheet: React.FC<{
  open: boolean;
  onClose: () => void;
  session: any;
  clubId: string | null;
  initialClub: any;
  term: 'clube' | 'grupo';
  onSaved: () => void; // recarrega clube no caller
}> = ({ open, onClose, session, clubId, initialClub, term, onSaved }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [privacy, setPrivacy] = useState<'open' | 'closed'>('closed');
  const [postBy, setPostBy] = useState<'leader-only' | 'moderators' | 'all' | 'approval'>('all');
  const [storiesPostBy, setStoriesPostBy] = useState<'leader-only' | 'moderators' | 'all'>('all');
  const [allowPoke, setAllowPoke] = useState(true);
  const [publicRanking, setPublicRanking] = useState(true);
  const [allowMemberQuiz, setAllowMemberQuiz] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [cover, setCover] = useState<string | null>(null);
  const [coverHue, setCoverHue] = useState<number>(22);
  const [uploadingCover, setUploadingCover] = useState(false);
  const [coverPicked, setCoverPicked] = useState<any>(null);
  const [banner, setBanner] = useState<string | null>(null);
  const [uploadingBanner, setUploadingBanner] = useState(false);
  const [bannerPicked, setBannerPicked] = useState<any>(null);

  // Sincroniza form com dados do clube quando abre
  useEffect(() => {
    if (open && initialClub) {
      setName(initialClub.name || '');
      setDescription(initialClub.description || '');
      setPrivacy(initialClub.privacy === 'open' ? 'open' : 'closed');
      setPostBy(initialClub.rules?.postBy || 'all');
      setStoriesPostBy(initialClub.rules?.storiesPostBy || 'all');
      setAllowPoke(initialClub.rules?.allowPoke !== false);
      setPublicRanking(initialClub.rules?.publicRanking !== false);
      setAllowMemberQuiz(!!initialClub.rules?.allowMemberQuiz);
      setCover(initialClub.customCoverUrl || initialClub.cover?.customUrl || null);
      setBanner(initialClub.customBannerUrl || null);
      setCoverHue(initialClub.cover?.hue ?? 22);
      setError(null);
    }
  }, [open, initialClub]);

  if (!open) return null;

  const handleCoverFile = async (file: any) => {
    if (!file || !session || !clubId) return;
    if (file.size > 8 * 1024 * 1024) { setError('Imagem muito grande (máx 8 MB).'); return; }
    setUploadingCover(true); setError(null);
    try {
      const { url } = await api.uploadClubCover(session, file);
      await api.patchClub(session, clubId, { customCoverUrl: url });
      setCover(url);
      onSaved();
    } catch (e: any) { setError(e?.message || 'Erro ao enviar capa'); }
    finally { setUploadingCover(false); }
  };
  const removeCover = async () => {
    if (!session || !clubId) return;
    setUploadingCover(true); setError(null);
    try { await api.patchClub(session, clubId, { customCoverUrl: null }); setCover(null); onSaved(); }
    catch (e: any) { setError(e?.message || 'Erro ao remover capa'); }
    finally { setUploadingCover(false); }
  };
  const handleBannerFile = async (file: any) => {
    if (!file || !session || !clubId) return;
    if (file.size > 8 * 1024 * 1024) { setError('Imagem muito grande (máx 8 MB).'); return; }
    setUploadingBanner(true); setError(null);
    try {
      const { url } = await api.uploadClubCover(session, file);
      await api.patchClub(session, clubId, { customBannerUrl: url });
      setBanner(url);
      onSaved();
    } catch (e: any) { setError(e?.message || 'Erro ao enviar banner'); }
    finally { setUploadingBanner(false); }
  };
  const removeBanner = async () => {
    if (!session || !clubId) return;
    setUploadingBanner(true); setError(null);
    try { await api.patchClub(session, clubId, { customBannerUrl: null }); setBanner(null); onSaved(); }
    catch (e: any) { setError(e?.message || 'Erro ao remover banner'); }
    finally { setUploadingBanner(false); }
  };

  const handleSave = async () => {
    if (!session || !clubId) {
      window.alert('Sessão expirada ou grupo não identificado.');
      return;
    }
    if (!name.trim() || name.trim().length > 80) {
      setError('Nome inválido — entre 1 e 80 caracteres.');
      return;
    }
    setSaving(true);
    setError(null);
    try {
      await api.patchClub(session, clubId, {
        name: name.trim(),
        description: description.trim() || null,
        privacy,
        postBy,
        storiesPostBy,
        allowPoke,
        publicRanking,
        allowMemberQuiz,
      });
      onSaved();
      onClose();
    } catch (e: any) {
      setError(e?.message || 'Erro ao salvar');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div onClick={onClose} style={{
        position: 'fixed', inset: 0, zIndex: 90,
        background: 'rgba(20,16,14,0.55)', backdropFilter: 'blur(4px)',
      }}/>
      <div style={{
        position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 91,
        background: 'var(--paper)', borderTopLeftRadius: 24, borderTopRightRadius: 24,
        padding: '14px 20px 32px', maxHeight: '90vh', overflowY: 'auto',
        boxShadow: '0 -16px 40px rgba(0,0,0,0.18)',
      }}>
        {/* Drag handle */}
        <div style={{
          width: 40, height: 4, borderRadius: 2, background: 'var(--line)',
          margin: '0 auto 16px',
        }}/>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
          <div className="serif" style={{ fontSize: 22, color: 'var(--ink)' }}>
            Configurações do <span style={{ fontStyle: 'italic', color: 'var(--ember)' }}>{term}</span>
          </div>
          <button onClick={onClose} style={{
            width: 32, height: 32, borderRadius: '50%',
            background: 'var(--paper-2)', border: '1px solid var(--line)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <Icon name="close" size={14}/>
          </button>
        </div>

        {error && (
          <div style={{
            padding: 12, borderRadius: 10, marginBottom: 14,
            background: 'rgba(192,58,42,0.08)', border: '1px solid rgba(192,58,42,0.3)',
            color: '#C03A2A', fontSize: 13,
          }}>{error}</div>
        )}

        {/* Nome */}
        <Field label="Nome">
          <input
            value={name}
            onChange={e => setName(e.target.value)}
            maxLength={80}
            style={inputStyle}
          />
          <div className="mono" style={{ fontSize: 9.5, color: 'var(--ink-4)', textAlign: 'right', marginTop: 4, letterSpacing: '0.06em' }}>
            {name.length}/80
          </div>
        </Field>

        {/* Descrição */}
        <Field label="Descrição">
          <textarea
            value={description}
            onChange={e => setDescription(e.target.value)}
            maxLength={280}
            rows={3}
            style={{ ...inputStyle, resize: 'vertical', minHeight: 70, fontFamily: 'inherit' }}
          />
          <div className="mono" style={{ fontSize: 9.5, color: 'var(--ink-4)', textAlign: 'right', marginTop: 4, letterSpacing: '0.06em' }}>
            {description.length}/280
          </div>
        </Field>

        {/* Capa poster (vitrine 2:3) */}
        <Field label="Capa (vitrine) · 2:3">
          <div style={{ fontSize: 11.5, color: 'var(--ink-4)', marginBottom: 8 }}>Aparece no Explorar e no perfil (pôster vertical)</div>
          <div style={{ position: 'relative', borderRadius: 12, overflow: 'hidden', width: 104, height: 156, margin: '0 auto', background: cover ? '#1a1a1a' : `linear-gradient(135deg, hsl(${coverHue} 55% 42%), hsl(${coverHue} 60% 24%))` }}>
            {cover && <img src={cover} alt="Capa" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
            <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(0deg, rgba(0,0,0,0.45), transparent 60%)' }} />
          </div>
          <label style={{ marginTop: 10, width: '100%', padding: '12px', borderRadius: 12, border: '1px dashed var(--line-strong)', color: 'var(--ink-2)', fontSize: 13, fontWeight: 500, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 7, cursor: uploadingCover ? 'default' : 'pointer', opacity: uploadingCover ? 0.6 : 1 }}>
            <Icon name="camera" size={16} color="var(--ink-2)" />
            {uploadingCover ? 'Enviando…' : (cover ? 'Trocar capa' : 'Alterar capa')} <span style={{ fontSize: 11, color: 'var(--ink-4)' }}>· câmera ou galeria</span>
            <input type="file" accept="image/*" style={{ display: 'none' }} disabled={uploadingCover} onChange={(e) => { const f = e.target.files && e.target.files[0]; e.target.value = ''; if (f) setCoverPicked(f); }} />
          </label>
          {cover && <button onClick={removeCover} disabled={uploadingCover} style={{ marginTop: 8, width: '100%', padding: '10px', background: 'transparent', color: 'var(--ink-3)', fontSize: 12.5, border: 'none', cursor: 'pointer' }}>Remover capa (voltar ao gradiente)</button>}
        </Field>

        {/* Banner do clube (4:3, dentro do clube) */}
        <Field label="Banner do clube · 4:3">
          <div style={{ fontSize: 11.5, color: 'var(--ink-4)', marginBottom: 8 }}>Faixa horizontal que aparece no topo, dentro do clube</div>
          <div style={{ position: 'relative', borderRadius: 12, overflow: 'hidden', aspectRatio: '4 / 3', background: banner ? '#1a1a1a' : `linear-gradient(135deg, hsl(${coverHue} 55% 42%), hsl(${coverHue} 60% 24%))` }}>
            {banner && <img src={banner} alt="Banner" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
            <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(0deg, rgba(0,0,0,0.45), transparent 60%)' }} />
          </div>
          <label style={{ marginTop: 10, width: '100%', padding: '12px', borderRadius: 12, border: '1px dashed var(--line-strong)', color: 'var(--ink-2)', fontSize: 13, fontWeight: 500, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 7, cursor: uploadingBanner ? 'default' : 'pointer', opacity: uploadingBanner ? 0.6 : 1 }}>
            <Icon name="camera" size={16} color="var(--ink-2)" />
            {uploadingBanner ? 'Enviando…' : (banner ? 'Trocar banner' : 'Adicionar banner')} <span style={{ fontSize: 11, color: 'var(--ink-4)' }}>· câmera ou galeria</span>
            <input type="file" accept="image/*" style={{ display: 'none' }} disabled={uploadingBanner} onChange={(e) => { const f = e.target.files && e.target.files[0]; e.target.value = ''; if (f) setBannerPicked(f); }} />
          </label>
          {banner && <button onClick={removeBanner} disabled={uploadingBanner} style={{ marginTop: 8, width: '100%', padding: '10px', background: 'transparent', color: 'var(--ink-3)', fontSize: 12.5, border: 'none', cursor: 'pointer' }}>Remover banner</button>}
        </Field>

        {/* Privacidade */}
        <Field label="Privacidade">
          <div style={{ display: 'flex', gap: 8 }}>
            <PrivBtn selected={privacy === 'open'} onClick={() => setPrivacy('open')}
              icon="🌐" label="Público" desc="Aparece no Explorar"/>
            <PrivBtn selected={privacy === 'closed'} onClick={() => setPrivacy('closed')}
              icon="🔒" label="Fechado" desc="Só por convite"/>
          </div>
        </Field>

        {/* Quem pode postar */}
        <Field label="Quem pode postar">
          <select value={postBy} onChange={e => setPostBy(e.target.value as any)} style={inputStyle}>
            <option value="all">Todos os membros</option>
            <option value="moderators">Moderadores e líder</option>
            <option value="leader-only">Só o líder</option>
            <option value="approval">Membros postam · líder aprova</option>
          </select>
        </Field>

        {/* Quem pode postar story */}
        <Field label="Quem pode postar story">
          <select value={storiesPostBy} onChange={e => setStoriesPostBy(e.target.value as any)} style={inputStyle}>
            <option value="all">Todos os membros</option>
            <option value="moderators">Moderadores e líder</option>
            <option value="leader-only">Só o líder</option>
          </select>
        </Field>

        {/* Toggles */}
        <Field label="Cutucadas" inline>
          <Toggle on={allowPoke} onChange={setAllowPoke}/>
        </Field>
        <Field label="Ranking público (membros veem progresso uns dos outros)" inline>
          <Toggle on={publicRanking} onChange={setPublicRanking}/>
        </Field>
        <Field label="Membros podem criar quizzes" inline>
          <Toggle on={allowMemberQuiz} onChange={setAllowMemberQuiz}/>
        </Field>

        {/* CTA */}
        <button
          onClick={handleSave}
          disabled={saving}
          style={{
            width: '100%', marginTop: 22, padding: '14px 18px',
            background: saving ? 'var(--paper-2)' : 'var(--ember)',
            color: saving ? 'var(--ink-3)' : 'var(--paper)',
            border: 'none', borderRadius: 14,
            fontSize: 14, fontWeight: 600,
            cursor: saving ? 'default' : 'pointer', fontFamily: 'inherit',
            boxShadow: saving ? 'none' : '0 12px 24px -10px rgba(199,83,26,0.5)',
          }}
        >
          {saving ? 'Salvando…' : 'Salvar alterações'}
        </button>
        <button onClick={onClose} disabled={saving} style={{
          width: '100%', marginTop: 8, padding: '12px',
          background: 'transparent', color: 'var(--ink-3)',
          fontSize: 13, border: 'none', cursor: 'pointer', fontFamily: 'inherit',
        }}>Cancelar</button>
      </div>
      {coverPicked && <CoverCropper file={coverPicked} onCancel={() => setCoverPicked(null)} onConfirm={(cf) => { setCoverPicked(null); handleCoverFile(cf); }} />}
      {bannerPicked && <CoverCropper file={bannerPicked} aspect={4/3} outW={1440} outH={1080} title="Ajustar banner" hint="Arraste pra posicionar · proporção 4:3 (banner do clube)" onCancel={() => setBannerPicked(null)} onConfirm={(cf) => { setBannerPicked(null); handleBannerFile(cf); }} />}
    </>
  );
};

const inputStyle: React.CSSProperties = {
  width: '100%', padding: '11px 14px', borderRadius: 10,
  background: 'var(--paper-2)', border: '1px solid var(--line)',
  color: 'var(--ink)', fontSize: 14, outline: 'none',
  fontFamily: 'inherit', boxSizing: 'border-box',
};

const Field: React.FC<{ label: string; inline?: boolean; children: React.ReactNode }> = ({ label, inline, children }) => (
  <div style={{
    marginBottom: 14,
    display: inline ? 'flex' : 'block',
    alignItems: inline ? 'center' : 'stretch',
    justifyContent: inline ? 'space-between' : 'flex-start',
    gap: 12,
  }}>
    <label className="mono" style={{
      display: 'block',
      fontSize: 9.5, letterSpacing: '0.14em', textTransform: 'uppercase',
      color: 'var(--ink-3)', fontWeight: 600,
      marginBottom: inline ? 0 : 6,
      flex: inline ? 1 : 'none',
    }}>{label}</label>
    {children}
  </div>
);

const PrivBtn: React.FC<{ selected: boolean; onClick: () => void; icon: string; label: string; desc: string }> = ({ selected, onClick, icon, label, desc }) => (
  <button onClick={onClick} style={{
    flex: 1, padding: 12, borderRadius: 12, textAlign: 'left',
    background: selected ? 'var(--paper-2)' : 'var(--paper)',
    border: '2px solid ' + (selected ? 'var(--ember)' : 'var(--line)'),
    cursor: 'pointer',
  }}>
    <div style={{ fontSize: 22, marginBottom: 4 }}>{icon}</div>
    <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--ink)' }}>{label}</div>
    <div style={{ fontSize: 11, color: 'var(--ink-3)', marginTop: 2 }}>{desc}</div>
  </button>
);

const Toggle: React.FC<{ on: boolean; onChange: (v: boolean) => void }> = ({ on, onChange }) => (
  <button
    onClick={() => onChange(!on)}
    style={{
      width: 44, height: 26, borderRadius: 13, position: 'relative',
      background: on ? 'var(--ember)' : 'var(--line)',
      border: 'none', cursor: 'pointer', transition: 'background 200ms',
    }}
  >
    <div style={{
      position: 'absolute', top: 2, left: on ? 20 : 2,
      width: 22, height: 22, borderRadius: '50%',
      background: 'var(--paper)',
      transition: 'left 200ms', boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
    }}/>
  </button>
);
